import { useParams } from "react-router";
import { useDotLegalQuery } from "@common/hooks/dotLegalReactQuery";
import { useLocalStorageTab } from "@common/hooks/useLocalStorageTab";
import { useUserContext } from "../../auth/userContextProvider/UserContextProvider";
import { InternalAssessmentGroupOverviewModel, InternalAssessmentGroupPlanTabId, InternalAssessmentGroupTabs } from "../InternalAssessmentGroups.types";
import useInternalAssessmentRowActions from "../internalAssessmentRowActions/InternalAssessmentRowActions.hooks";

export default function useInternalAssessmentGroupOverview() {
    const { id } = useParams<{ id: string }>();
    const { customerId } = useUserContext();

    const [selectedTab, setSelectedTab] = useLocalStorageTab(
        `internal-assessment-group-plan-tab-${customerId}`,
        internalAssessmentGroupPlanTabMapping,
        InternalAssessmentGroupPlanTabId.Assessments
    );

    const { isLoading, data, refetch } = useDotLegalQuery<InternalAssessmentGroupOverviewModel>(`/internalAssessmentGroups/${id}/overview`);

    const rowActions = useInternalAssessmentRowActions({ refetch: () => refetch(), refetchPlanLimit: () => {} });

    return {
        id,
        data,
        isLoading,
        refetch,
        rowActions,
        selectedTab,
        setSelectedTab,
    };
}

const internalAssessmentGroupPlanTabMapping: Record<number, InternalAssessmentGroupPlanTabId> = {
    [InternalAssessmentGroupTabs.Assessments]: InternalAssessmentGroupPlanTabId.Assessments,
    [InternalAssessmentGroupTabs.Tasks]: InternalAssessmentGroupPlanTabId.Tasks,
};
